import { GridApi } from 'ag-grid-community';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ContextMenu } from './models/context-menu';
import { ContextMenuItem } from './models/context-menu-item';

@Injectable({
  providedIn: 'root'
})
export class ContextMenuService {
  private menu$ = new BehaviorSubject<ContextMenu>({
    isOpen: false,
    items: [],
    left: 0,
    top: 0
  });

  private get menu() {
    return this.menu$.value;
  }

  public observeContextMenu() {
    return this.menu$.asObservable();
  }

  public add(item: ContextMenuItem) {
    this.menu.items.push(item);
    this.refresh();
  }

  public onContextMenu(event: PointerEvent | MouseEvent, items?: ContextMenuItem[]) {
    const isAnotherKeyDown = event.ctrlKey || event.altKey || event.metaKey || event.shiftKey;

    if (isAnotherKeyDown) {
      return; // do nothing use the default context menu
    }

    if (
      this.open(
        {
          left: event.clientX,
          top: event.clientY
        },
        items
      )
    ) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  public open({ left, top }: { left: number; top: number }, items?: ContextMenuItem[]) {
    this.menu.items = items ?? [];

    if (this.menu.items.length <= 0) {
      return false;
    }

    this.menu.left = left;
    this.menu.top = top;
    this.menu.isOpen = true;
    this.refresh();
    return true;
  }

  public closeMenu() {
    this.menu.items = [];
    this.menu.isOpen = false;
    this.refresh();
  }

  private refresh() {
    this.menu$.next(this.menu);
  }

  public getGridApiItems<T>(getApi: () => GridApi<T> | undefined, disableCellEdit$?: Observable<boolean>) {
    const items: ContextMenuItem[] = [
      {
        titleKey: 'shared.assignmentBoard.contextMenu.cut',
        subTitleKey: 'shared.assignmentBoard.contextMenu.cutHint',
        disabled$: disableCellEdit$,
        separator: 'above',
        click: () => {
          getApi()?.cutToClipboard();
          return Promise.resolve();
        }
      },
      {
        titleKey: 'shared.assignmentBoard.contextMenu.copy',
        subTitleKey: 'shared.assignmentBoard.contextMenu.copyHint',
        click: () => {
          getApi()?.copyToClipboard();
          return Promise.resolve();
        }
      },
      {
        titleKey: 'shared.assignmentBoard.contextMenu.paste',
        subTitleKey: 'shared.assignmentBoard.contextMenu.pasteHint',
        disabled$: disableCellEdit$,
        click: () => {
          getApi()?.pasteFromClipboard();
          return Promise.resolve();
        }
      }
    ];
    return items;
  }
}
